// contains single-line only -- in a textarea, the return button inserts a newline.
export const NAVIGABLE_INPUT_TYPES = new Set(['text', 'number', 'email', 'password', 'tel']);

export const ENTER_KEY_HINTS = {
  enter: 'enter',
  done: 'done',
  go: 'go',
  next: 'next',
  previous: 'previous',
  search: 'search',
  send: 'send',
} as const;

export type EnterKeyHint = (typeof ENTER_KEY_HINTS)[keyof typeof ENTER_KEY_HINTS];

export function resolveEnterKeyHint(
  type: string,
  isLast: boolean,
  explicit?: EnterKeyHint,
): EnterKeyHint | undefined {
  return (
    explicit ??
    (NAVIGABLE_INPUT_TYPES.has(type)
      ? isLast
        ? ENTER_KEY_HINTS.done
        : ENTER_KEY_HINTS.next
      : undefined)
  );
}
